import _ from 'lodash';

import { createDocuments } from 'factories/document/documentFactory';
import * as Models from 'models';

export function normalizeDocuments<T extends Models.GetProjectDataProcessArgs>(args: T): T {
  return _.set(args, 'assets.documents', createDocuments(args.assets.documents));
}
